import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Eye } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToMechanism = () => {
    document.getElementById('mechanism')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="hero" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-slate-900" data-id="element-48">
      {/* Background Gradients */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800" data-id="element-49" />
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-teal-500/10 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/3" data-id="element-50" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[100px] translate-y-1/3 -translate-x-1/4" data-id="element-51" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-52">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-53">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-54">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} className="inline-flex items-center space-x-2 bg-slate-800/50 rounded-full px-4 py-1.5 mb-8 border border-slate-700" data-id="element-55">
              <span className="w-2 h-2 rounded-full bg-teal-500 animate-pulse" data-id="element-56" />
              <span className="text-sm font-medium text-teal-400 tracking-wide uppercase" data-id="element-57">
                Clinical Breakthrough
              </span>
            </motion.div>

            <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight mb-6 tracking-tight" data-id="element-58">
              The Patient You See{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-blue-500" data-id="element-59">
                Every Week
              </span>
            </h1>

            <p className="text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-60">
              You know the story. The initial response was promising, but now
              they've plateaued. Fluid remains. Vision fluctuates. And you're
              both looking for a way forward that doesn't involve monthly
              injections forever.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-61">
              <Button size="lg" onClick={scrollToMechanism} rightIcon={<ArrowRight className="w-5 h-5" data-id="element-63" />} className="w-full sm:w-auto" data-id="element-62">
                See What Changes Everything
              </Button>
            </div>
          </motion.div>

          {/* Visual Abstract */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="relative hidden lg:block" data-id="element-64">
            <div className="relative w-full aspect-square max-w-[600px] mx-auto" data-id="element-65">
              {/* Abstract Eye Representation */}
              <div className="absolute inset-0 border border-slate-700/50 rounded-full animate-[spin_60s_linear_infinite]" data-id="element-66" />
              <div className="absolute inset-8 border border-slate-700/30 rounded-full animate-[spin_40s_linear_infinite_reverse]" data-id="element-67" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-68">
                <div className="relative w-64 h-64 bg-gradient-to-tr from-teal-500/20 to-blue-600/20 rounded-full backdrop-blur-sm border border-white/10 flex items-center justify-center" data-id="element-69">
                  <Eye className="w-32 h-32 text-teal-400/80" strokeWidth={1} data-id="element-70" />

                  {/* Floating elements */}
                  <motion.div animate={{
                  y: [0, -10, 0]
                }} transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} className="absolute -top-12 -right-4 bg-slate-800 p-4 rounded-xl border border-slate-700 shadow-xl" data-id="element-71">
                    <div className="text-xs text-slate-400 uppercase tracking-wider mb-1" data-id="element-72">
                      Target 1
                    </div>
                    <div className="font-bold text-white" data-id="element-73">VEGF-A</div>
                  </motion.div>

                  <motion.div animate={{
                  y: [0, 10, 0]
                }} transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: 'easeInOut',
                  delay: 1
                }} className="absolute -bottom-8 -left-8 bg-slate-800 p-4 rounded-xl border border-slate-700 shadow-xl" data-id="element-74">
                    <div className="text-xs text-slate-400 uppercase tracking-wider mb-1" data-id="element-75">
                      Target 2
                    </div>
                    <div className="font-bold text-teal-400" data-id="element-76">Ang-2</div>
                  </motion.div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}